module.exports = __webpack_public_path__ + "img/empty.4b691142.png";